<template>
  <div class="modal fade" id="view-auto-action-modal" aria-hidden="true" aria-labelledby="exampleGrid" role="dialog">
      <div class="modal-dialog modal-simple modal-center">
        <div class="modal-content">
          <div class="modal-header">
            <div class="container">
              <div class="row header">
                <div class="col-8">
                  <h4 class="modal-title">
                    {{ title ? title : $t("booking.detail.messages.auto_action_modal_title") }}
                  </h4>
                </div>
                <div class="col-4">
                  <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click.prevent="closeModal('#view-auto-action-modal')">
                    <span aria-hidden="true" class="close-btn">&times;</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div :class="notificationLoading ? 'modal-body d-flex justify-content-center align-items-center' : 'modal-body'" style="min-height: 300px;">
            <div v-if="notificationLoading">
              <v-loading :isLoading="notificationLoading" :height="50" :width="50" :viewbox="'0 0 50 50'" :cx="25" :cy="25" :r="22" :isHeightAuto="true"></v-loading>
            </div>
            <div v-if="!notificationLoading">
              <div class="row" v-if="autoActionContent.subject">
                <div class="col-12">
                  <div class="content-item">
                    <label for="auto-action-subject" class="control-label">
                      {{ $t("input.subject") }}
                    </label>
                    <h3 id="auto-action-subject" >{{ autoActionContent.subject }}</h3>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <div class="content-item">
                    <label for="auto-action-message-content" class="control-label">
                      {{ $t("input.message_content") }}
                    </label>
                    <div id="auto-action-message-content" v-html="autoActionContent.message || autoActionContent"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
    import mixin from '../../../../mixins/mixin';

    export default {
        name: 'NotificationContent',
        props: [
          'title',
          'autoActionContent',
          'notificationLoading'
        ],
        components: {
          VLoading: require('components/loading/loading.vue'),
        },
        mixins: [ mixin ],
    }
</script>



// WEBPACK FOOTER //
// NotificationContentModal.vue?7ab252ae